import e from "../managers/braze-instance.js";
import dt from "./utils/push-utils.js";
export function isPushBlocked() {
  if (e.rr()) return dt.isPushBlocked();
}
